"use client";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { READ_LESS, READ_MORE } from "../../../constants/common/common";
import Typography from "../../../components/atoms/typography";
import { formatClassNames } from "../../../utils/common";

/** */
export const LongDescription = ({ description, isShortDescription = false }) => {
  const [showMore, setShowMore] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(READ_MORE);
  const [isTextOverflowed, setIsTextOverflowed] = useState(false);

  // Ensure this runs only on the client
  useEffect(() => {
    setIsMounted(true);
  }, []);

  /**
   * This method is handling readmore/readless footer description
   */
  const onHandleViewMore = () => {
    setShowMore((prevShowMore) => {
      const newShowMore = !prevShowMore;
      setButtonLabel(newShowMore ? READ_LESS : READ_MORE);
      return newShowMore;
    });
  };

  /**
   * Check if text is overflowed (text exceeds container width)
   */
  const checkTextOverflow = () => {
    const shortDescriptionElement = document.getElementById("shortDescription");
    if (shortDescriptionElement) {
      // Check if text content is wider than the container
      // scrollWidth includes the full width of content even if hidden
      // clientWidth is the visible width
      setIsTextOverflowed(shortDescriptionElement.scrollWidth > shortDescriptionElement.clientWidth);
    }
  };

  useEffect(() => {
    if (isMounted && !isShortDescription) {
      const longDescriptionSec = document.getElementById("longDescription");
      if (longDescriptionSec && longDescriptionSec.children.length > 0) {
        const allContent = longDescriptionSec.children;
        const firstElements = document.createElement("div");
        const hiddenSec = document.createElement("div");
        firstElements.classList = "w-full";
        hiddenSec.classList = `w-full ${showMore ? "" : "hidden"}`;
        Array.from(allContent).forEach((element, index) => {
          if (index <= 1) {
            firstElements.appendChild(element);
          } else {
            hiddenSec.appendChild(element);
          }
        });
        longDescriptionSec.innerHTML = "";
        longDescriptionSec.appendChild(firstElements);
        longDescriptionSec.appendChild(hiddenSec);
      }
    } else if (isMounted && isShortDescription) {
      const shortDescriptionElement = document.getElementById("shortDescription");
      if (showMore) {
        shortDescriptionElement.classList.remove("overflow-hidden", "text-ellipsis", "whitespace-nowrap");
      } else {
        shortDescriptionElement.classList.add("overflow-hidden", "text-ellipsis", "whitespace-nowrap");
        setTimeout(checkTextOverflow, 0);
      }
    }
  }, [isMounted, showMore]);

  return (
    <>
      {!isShortDescription ? (
        <article
          className="p-16 md:p-40 md:pb-0"
          id="longDescription"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      ) : (
        description && (
          <div className={formatClassNames("mb-20", showMore ? "block" : "flex")}>
            <Typography
              classes="mx-2 overflow-hidden text-ellipsis whitespace-nowrap text-16 text-12 font-400 text-[#999999]"
              Tag={"p"}
              variant="body"
              id="shortDescription"
            >
              {description}
            </Typography>
            {isTextOverflowed && (
              <div className={formatClassNames("flex justify-end", showMore ? "w-full" : "w-[10%] min-w-[80px]")}>
                <button
                  type="button"
                  onClick={onHandleViewMore}
                  className="inline-flex justify-end text-14 font-500 text-fnp-500"
                >
                  {buttonLabel}
                </button>
              </div>
            )}
          </div>
        )
      )}
      {!isShortDescription && (
        <button
          type="button"
          onClick={onHandleViewMore}
          className="mr-40 inline-flex justify-end text-14 font-500 text-fnp-500"
        >
          {buttonLabel}
        </button>
      )}
    </>
  );
};

LongDescription.propTypes = {
  description: PropTypes.string.isRequired,
  isShortDescription: PropTypes.bool,
};
